import * as React from "react";
import Sniffer from "snifferjs";
export function useUserAgent() {
    const sniff = React.useMemo(() => Sniffer(window.navigator.userAgent), []);
    return sniff;
}
